import React from 'react';
import usePushNotifications from '../Hooks/usePushNotifications';

export default function PushListener() {
  usePushNotifications();     // ⬅️  just run the hook
  return null;                // nothing to render
}
